import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_court = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT}/`);
};
export const dispute_resolution_getbyid_court = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT}/by-id/${id}`);
};
export const dispute_resolution_add_court = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_COURT}/`, data);
};
export const dispute_resolution_update_court = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_COURT}/${id}`, data);
};
export const dispute_resolution_delete_court = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_COURT}/${id}`);
};

